import type { Components } from '@mui/material/styles';
import { type Theme } from '@mui/material/styles';

export const formHelperTextTheme: Pick<
  Components<Theme>,
  'MuiFormHelperText'
> = {
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        // align text with input field
        marginLeft: 'unset',
      },
    },
  },
};
